// import React, { useEffect, useState } from "react"
// import displayINRCurrency from "../helpers/displayCurrency"
// import { MdDelete, MdEdit } from "react-icons/md"
// import UploadProduct from "../components/UploadProduct"

// const AllProducts = () => {

// const [products,setProducts] = useState([])
// const [filteredProducts,setFilteredProducts] = useState([])
// const [openUpload,setOpenUpload] = useState(false)
// const [search,setSearch] = useState("")

// useEffect(()=>{
// fetchProducts()
// },[])

// useEffect(()=>{

// const result = products.filter(p =>
// p.productName.toLowerCase().includes(search.toLowerCase())
// )

// setFilteredProducts(result)

// },[search,products])


// const fetchProducts = async()=>{

// const res = await fetch(
// "https://lappyshop.onrender.com/api/get-product",
// { credentials:"include" }
// )

// const data = await res.json()

// if(data.success){

// setProducts(data.data)
// setFilteredProducts(data.data)

// }

// }

// const updateStock = async(id,stock)=>{

// await fetch(
// "https://lappyshop.onrender.com/api/update-stock",
// {
// method:"POST",
// credentials:"include",
// headers:{ "Content-Type":"application/json"},
// body:JSON.stringify({
// productId:id,
// stock
// })
// }
// )

// fetchProducts()

// }

// const deleteProduct = async(id)=>{

// if(!window.confirm("Delete this product?")) return

// await fetch(
// "https://lappyshop.onrender.com/api/delete-product",
// {
// method:"POST",
// credentials:"include",
// headers:{ "Content-Type":"application/json"},
// body:JSON.stringify({ productId:id })
// }
// )

// fetchProducts()

// }

// return (

// <div className="space-y-6">

// {/* HEADER */}

// <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">

// <h1 className="text-2xl font-bold">
// Inventory Management
// </h1>

// <div className="flex gap-3">

// <input
// type="text"
// placeholder="Search product..."
// className="border rounded px-3 py-2 text-sm"
// value={search}
// onChange={(e)=>setSearch(e.target.value)}
// />

// <button
// onClick={()=>setOpenUpload(true)}
// className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
// >
// + Add Product
// </button>

// </div>

// </div>


// {/* TABLE (Desktop) */}

// <div className="hidden md:block overflow-x-auto bg-white rounded shadow">

// <table className="w-full text-sm">

// <thead className="bg-gray-100">

// <tr>

// <th className="p-3 text-left">Product</th>
// <th>Category</th>
// <th>Price</th>
// <th>Selling</th>
// <th>RAM</th>
// <th>Storage</th>
// <th>Condition</th>
// <th>Stock</th>
// <th>Status</th>
// <th>Actions</th>

// </tr>

// </thead>

// <tbody>

// {filteredProducts.map((product)=>{

// const isLow = product.stock < 5
// const isOut = product.stock === 0

// return(

// <tr
// key={product._id}
// className={`border-t hover:bg-gray-50 ${isLow && "bg-red-50"}`}
// >

// <td className="p-3 flex items-center gap-3">

// <img
// src={product.productImage?.[0] || "/no-image.png"}
// className="w-12 h-12 object-contain border"
// />

// <div>

// <p className="font-medium">
// {product.productName}
// </p>

// <p className="text-xs text-gray-500">
// {product.brand}
// </p>

// </div>

// </td>

// <td className="text-center">
// {product.category}
// </td>

// <td className="text-center">
// {displayINRCurrency(product.price)}
// </td>

// <td className="text-center">
// {displayINRCurrency(product.sellingPrice)}
// </td>

// <td className="text-center text-xs">
// {product.ramOptions?.join(", ")}
// </td>

// <td className="text-center text-xs">
// {product.storageOptions?.join(", ")}
// </td>

// <td className="text-center">

// <span className="bg-gray-200 px-2 py-1 rounded text-xs">
// {product.condition}
// </span>

// </td>

// <td className="text-center">

// <input
// type="number"
// defaultValue={product.stock}
// className="border w-16 p-1 rounded text-center"
// onBlur={(e)=>updateStock(product._id,Number(e.target.value))}
// >

// </input>

// </td>

// <td className="text-center">

// {isOut ? (

// <span className="text-red-600 font-medium">
// Out
// </span>

// ) : isLow ? (

// <span className="text-orange-600 font-medium">
// Low
// </span>

// ) : (

// <span className="text-green-600 font-medium">
// In Stock
// </span>

// )}

// </td>

// <td className="text-center flex justify-center gap-2">

// <button className="text-blue-600 text-lg">
// <MdEdit/>
// </button>

// <button
// className="text-red-600 text-lg"
// onClick={()=>deleteProduct(product._id)}
// >
// <MdDelete/>
// </button>

// </td>

// </tr>

// )

// })}

// </tbody>

// </table>

// </div>


// {/* MOBILE CARD VIEW */}

// <div className="md:hidden space-y-4">

// {filteredProducts.map((product)=>{

// const isLow = product.stock < 5
// const isOut = product.stock === 0

// return(

// <div key={product._id} className="bg-white p-4 rounded shadow">

// <div className="flex gap-3">

// <img
// src={product.productImage?.[0]}
// className="w-16 h-16 object-contain border"
// />

// <div>

// <p className="font-medium">
// {product.productName}
// </p>

// <p className="text-sm text-gray-500">
// {product.brand}
// </p>

// <p className="text-sm">
// {displayINRCurrency(product.sellingPrice)}
// </p>

// </div>

// </div>

// <div className="flex justify-between mt-3 text-sm">

// <span>{product.category}</span>

// <span>

// {isOut ? "Out of Stock" : isLow ? "Low Stock" : "In Stock"}

// </span>

// </div>

// <div className="flex justify-between mt-3">

// <button
// className="text-red-600"
// onClick={()=>deleteProduct(product._id)}
// >
// Delete
// </button>

// <input
// type="number"
// defaultValue={product.stock}
// className="border w-16 p-1 rounded text-center"
// onBlur={(e)=>updateStock(product._id,Number(e.target.value))}
// >

// </input>

// </div>

// </div>

// )

// })}

// </div>


// {/* UPLOAD MODAL */}

// {openUpload && (

// <UploadProduct
// onClose={()=>setOpenUpload(false)}
// fetchData={fetchProducts}
// />

// )}

// </div>

// )

// }

// // export default AllProducts
// import React,{useEffect,useState} from "react"
// import displayINRCurrency from "../helpers/displayCurrency"
// import UploadProduct from "../components/UploadProduct"
// import {MdDelete,MdEdit} from "react-icons/md"

// const AllProducts = ()=>{

// const [products,setProducts]=useState([])
// const [openUpload,setOpenUpload]=useState(false)

// const fetchProducts = async()=>{

// const res = await fetch(
// "https://lappyshop.onrender.com/api/get-product"
// )

// const data = await res.json()

// if(data.success){

// setProducts(data.data)

// }

// }

// useEffect(()=>{
// fetchProducts()
// },[])

// const deleteProduct = async(id)=>{

// if(!window.confirm("Delete product?")) return

// await fetch(
// "https://lappyshop.onrender.com/api/delete-product",
// {
// method:"POST",
// headers:{"content-type":"application/json"},
// body:JSON.stringify({productId:id})
// }
// )

// fetchProducts()

// }

// return(

// <div>

// <div className="flex justify-between mb-6">

// <h1 className="text-2xl font-bold">

// Inventory Management

// </h1>

// <button
// onClick={()=>setOpenUpload(true)}
// className="bg-blue-600 text-white px-4 py-2 rounded"
// >

// Add Product

// </button>

// </div>

// <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">

// {products.map(product=>{

// const totalStock = product.variants?.reduce(
// (a,b)=>a+b.stock,0
// )

// return(

// <div
// key={product._id}
// className="border rounded p-4 bg-white shadow"
// >

// <img
// src={product.productImage?.[0]}
// className="h-40 object-contain mx-auto"
// />

// <h2 className="font-semibold mt-3">

// {product.productName}

// </h2>

// <p className="text-sm text-gray-500">

// {product.brand}

// </p>

// <p className="text-red-600 font-bold">

// {displayINRCurrency(product.variants?.[0]?.price)}

// </p>

// <p className="text-sm">

// Stock : {totalStock}

// </p>

// {/* VARIANTS */}

// <div className="mt-2 text-xs">

// {product.variants?.map((v,i)=>(

// <p key={i}>

// {v.ram} / {v.storage} → {displayINRCurrency(v.price)}

// </p>

// ))}

// </div>

// <div className="flex justify-end gap-3 mt-3">

// <button className="text-blue-600">

// <MdEdit/>

// </button>

// <button
// onClick={()=>deleteProduct(product._id)}
// className="text-red-600"
// >

// <MdDelete/>

// </button>

// </div>

// </div>

// )

// })}

// </div>

// {openUpload &&(

// <UploadProduct
// onClose={()=>setOpenUpload(false)}
// fetchData={fetchProducts}
// />

// )}

// </div>

// )

// }

// export default AllProducts
import React, { useEffect, useState } from "react";
import displayINRCurrency from "../helpers/displayCurrency";
import UploadProduct from "../components/UploadProduct";
import { MdDelete, MdEdit } from "react-icons/md";
import { motion } from "framer-motion";

const AllProducts = () => {

  const [products, setProducts] = useState([]);
  const [openUpload, setOpenUpload] = useState(false);
  const [editData, setEditData] = useState(null);

  /* 🔥 FETCH */
  const fetchProducts = async () => {
    try {
      const res = await fetch("https://lappyshop.onrender.com/api/get-product");
      const data = await res.json();

      if (data.success) {
        setProducts(data.data);
      }
    } catch (err) {
      console.log("Fetch error", err);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  /* 🔥 DELETE */
  const deleteProduct = async (id) => {
    if (!window.confirm("Delete product?")) return;

    try {
      const res = await fetch("https://lappyshop.onrender.com/api/delete-product", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ productId: id }),
      });

      const data = await res.json();

      if (data.success) {
        fetchProducts();
      } else {
        alert("Delete failed");
      }

    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="p-4 bg-gray-50 min-h-screen">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-6">

        <h1 className="text-3xl font-bold">
          Inventory Management
        </h1>

        <button
          onClick={() => setOpenUpload(true)}
          className="bg-blue-600 text-white px-5 py-2 rounded-lg shadow hover:bg-blue-700"
        >
          + Add Product
        </button>

      </div>

      {/* GRID */}
      <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">

        {products.map((product, i) => {

          const totalStock = product?.variants?.reduce(
            (a, b) => a + (b.stock || 0), 0
          ) || 0;

          const price = product?.variants?.[0]?.price || 0;

          return (
            <motion.div
              key={product._id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.05 }}
              className="bg-white rounded-2xl shadow hover:shadow-xl transition p-4 group"
            >

              {/* IMAGE */}
              <div className="h-40 flex items-center justify-center overflow-hidden">
                <img
                  src={product.productImage?.[0]}
                  className="h-full object-contain group-hover:scale-110 transition"
                />
              </div>

              {/* DETAILS */}
              <h2 className="font-semibold mt-3 line-clamp-1">
                {product.productName}
              </h2>

              <p className="text-sm text-gray-500 capitalize">
                {product.brand}
              </p>

              <p className="text-blue-600 font-bold text-lg mt-1">
                {displayINRCurrency(price)}
              </p>

              <p className="text-sm text-gray-600">
                Stock: {totalStock}
              </p>

              {/* VARIANTS */}
              <div className="mt-2 text-xs space-y-1 max-h-16 overflow-y-auto">
                {product?.variants?.map((v, i) => (
                  <p key={i}>
                    {v.ram} / {v.storage} → {displayINRCurrency(v.price || 0)}
                  </p>
                ))}
              </div>

              {/* ACTIONS */}
              <div className="flex justify-end gap-3 mt-4 opacity-0 group-hover:opacity-100 transition">

                <button
                  onClick={() => setEditData(product)}
                  className="p-2 bg-blue-100 text-blue-600 rounded-full hover:bg-blue-200"
                >
                  <MdEdit />
                </button>

                <button
                  onClick={() => deleteProduct(product._id)}
                  className="p-2 bg-red-100 text-red-600 rounded-full hover:bg-red-200"
                >
                  <MdDelete />
                </button>

              </div>

            </motion.div>
          );
        })}

      </div>

      {/* ADD PRODUCT */}
      {openUpload && (
        <UploadProduct
          onClose={() => setOpenUpload(false)}
          fetchData={fetchProducts}
        />
      )}

      {/* EDIT PRODUCT */}
      {editData && (
        <UploadProduct
          productData={editData}
          onClose={() => setEditData(null)}
          fetchData={fetchProducts}
        />
      )}

    </div>
  );
};

export default AllProducts;